import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountConsentsComponent } from './components/account-consents/account-consents.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ConsentsAcceptedDialogComponent,
} from './components/consents-accepted-dialog/consents-accepted-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { AccountConsentsRoutingModule } from './account-consents-routing-module';
import { FabComponent } from '../shared/components/fab/fab.component';
import { ContainerComponent } from '../shared/components/container/container.component';

@NgModule({
  declarations: [
    AccountConsentsComponent,
    ConsentsAcceptedDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AccountConsentsRoutingModule,
    FabComponent,
    ContainerComponent,
    SharedModule
  ],
  exports: [],
})
export class AccountConsentsModule {
}
